// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
  z-index: 9999;
}

.wizard-modal {
  background: #1E1E1E;
  border: 1.631px solid #364153;
  border-radius: 16px;
  width: 100%;
  max-width: 900px;
  padding: 40px 56px;
  max-height: 90vh;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

.wizard-content-box {
  background-color: transparent;
}

.step-circle {
  width: 70px;
  height: 70px;
  background-color: #333;
  color: #fff;
  font-size: 1.25rem;
  border: 2px solid #4d4d4d;
  transition: all 0.3s ease;
}

.step-circle img, .step-circle i {
  filter: brightness(0) invert(1);
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-circle.active {
  background-color: #FF9600;
  border-color: #FF9600;
  box-shadow: 0 0 10px rgba(255, 150, 0, 0.5);
}

.step-circle.completed {
  background-color: #FF9600;
  border-color: #FF9600;
  color: #ffffff;
}

.progress-line {
  height: 2px;
  background: linear-gradient(to right, #FF9600 50%, #4d4d4d 50%);
  background-size: 200% 100%;
  background-position: right bottom;
  width: 524px; /* 192px gap + 70px circles */
  top: 35px;
  left: 50%;
  transform: translateX(-50%);
}

.domo-btn-solid {
  background-color: #f09502;
  border-color: #f09502;
  font-weight: 500;
  padding: 0.5rem 2rem;
  border-radius: 8px;
}

.domo-btn-solid:hover:not(:disabled) {
  background-color: #d18102;
}

.domo-btn-solid:disabled {
  background-color: #6c757d;
  border-color: #6c757d;
  opacity: 0.65;
}

.domo-btn-outline {
  border: 1px solid #f09502;
  color: #f09502;
  font-weight: 500;
  padding: 0.5rem 2rem;
  border-radius: 8px;
}

.domo-btn-outline:hover {
  background-color: rgba(240, 149, 2, 0.1);
  color: #f09502;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/new-proyect/project-wizard/project-wizard.component.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,+DAA+D;EAC/D,0BAA0B;EAC1B,iCAAiC;EACjC,YAAY,EAAE,6BAA6B;EAC3C,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB","sourcesContent":[".wizard-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.75);\n  backdrop-filter: blur(4px);\n  z-index: 9999;\n}\n\n.wizard-modal {\n  background: #1E1E1E;\n  border: 1.631px solid #364153;\n  border-radius: 16px;\n  width: 100%;\n  max-width: 900px;\n  padding: 40px 56px;\n  max-height: 90vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n.wizard-content-box {\n  background-color: transparent;\n}\n\n.step-circle {\n  width: 70px;\n  height: 70px;\n  background-color: #333;\n  color: #fff;\n  font-size: 1.25rem;\n  border: 2px solid #4d4d4d;\n  transition: all 0.3s ease;\n}\n\n.step-circle img, .step-circle i {\n  filter: brightness(0) invert(1);\n  width: 30px;\n  height: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.step-circle.active {\n  background-color: #FF9600;\n  border-color: #FF9600;\n  box-shadow: 0 0 10px rgba(255, 150, 0, 0.5);\n}\n\n.step-circle.completed {\n  background-color: #FF9600;\n  border-color: #FF9600;\n  color: #ffffff;\n}\n\n.progress-line {\n  height: 2px;\n  background: linear-gradient(to right, #FF9600 50%, #4d4d4d 50%);\n  background-size: 200% 100%;\n  background-position: right bottom;\n  width: 524px; /* 192px gap + 70px circles */\n  top: 35px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n\n.domo-btn-solid {\n  background-color: #f09502;\n  border-color: #f09502;\n  font-weight: 500;\n  padding: 0.5rem 2rem;\n  border-radius: 8px;\n}\n\n.domo-btn-solid:hover:not(:disabled) {\n  background-color: #d18102;\n}\n\n.domo-btn-solid:disabled {\n  background-color: #6c757d;\n  border-color: #6c757d;\n  opacity: 0.65;\n}\n\n.domo-btn-outline {\n  border: 1px solid #f09502;\n  color: #f09502;\n  font-weight: 500;\n  padding: 0.5rem 2rem;\n  border-radius: 8px;\n}\n\n.domo-btn-outline:hover {\n  background-color: rgba(240, 149, 2, 0.1);\n  color: #f09502;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
